<template>
  <div class="xs-12 event-panel">
    <div class="dea-heading--medium__l">I miei eventi formativi</div>
    <p class="dea-heading--medium__s">I prossimi eventi in programma e corsi da seguire:</p>
    <div class="event-panel__container">
      <div class="grid">
        <div v-for="event in events" :key="event.id" class="event-panel__item xs-12 s-12 m-4 l-3">
          <CardEventBasic :event="event.linked_event" :use-router="useRouter" />
        </div>
        <div class="event-panel__link xs-12 s-12 m-4 l-2">
          <Links
            v-if="componentType === 'a'"
            class="dea-links dea-links--align-right dea-links--no-border dea-links--decoration"
            :class="`dea-links--decoration-${linkColor}`"
            label-class="dea-heading--medium-l"
            icon="go-to"
            v-bind="linkDestination"
          >
            Vai all'elenco completo
          </Links>
          <router-link
            v-else
            class="dea-links dea-links--align-right dea-links--no-border dea-links--decoration"
            :class="`dea-links--decoration-${linkColor}`"
            v-bind="linkDestination"
          >
            <span class="dea-links__label dea-heading--medium-l"> Vai all'elenco completo </span>
            <span class="icon dea-links__icon dea-ico-go-to" aria-label="icona vai a"></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardEventBasic from "@/components/patterns/CardEventBasic";
import Links from "@/components/elements/Links";

export default {
  name: "EventPanel",
  components: { CardEventBasic, Links },
  props: {
    events: {
      type: Array,
      default: () => [],
    },
    linkType: {
      type: String,
      default: "a",
      validator: value => {
        return ["a", "router"].indexOf(value) !== -1;
      },
    },
    linkColor: {
      type: String,
      required: true,
    },
    useRouter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      registrationBase: this.$root.asyncConf ? this.$root.asyncConf.formazioneMyEventsUrl : "#",
    };
  },
  computed: {
    linkDestination() {
      return this.linkType === "a" ? { href: this.registrationBase } : { to: { name: "events" } };
    },
    componentType() {
      return this.linkType === "a" ? "Links" : "router-link";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/system.utils";

.event-panel {
  margin-bottom: $space-large;

  &__container {
    @include media("<=s") {
      flex-wrap: wrap;
    }
    display: flex;
  }

  &__item {
    margin-bottom: $space-base;
  }
}
</style>
